export default __webpack_public_path__ + "static/media/logo.780a2066.svg";